// extracted by mini-css-extract-plugin
export var label = "_6w-1";
export var reminder = "_6w-0";